module.exports = __webpack_public_path__ + "img/9-6.43c1c6c8.png";